import React, { Component } from 'react';
import './HouseTypeFilter.css';
import CheckboxFilter from './CheckboxFilter';
import MenuType from '../enums/MenuType';
import Option from '../choices/Option';
import SubMenuHeader from './SubMenuHeader';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import Once from '../core/Once';
export default class FeaturesFilter extends Component {
	constructor(props){
		super(props);
		const {onSelectedOptionsChange} = props;
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._checkboxFilter=React.createRef();
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this.load = this.load.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.setFromWhatAreYouLookingForViewModel= this.setFromWhatAreYouLookingForViewModel.bind(this);
		this._handleSelectedOptionsChanged= this._handleSelectedOptionsChanged.bind(this);;
		this._setSelectedFeatures= this._setSelectedFeatures.bind(this);
		this.filterPlots = this.filterPlots.bind(this);
		this.clear = this.clear.bind(this);
		this._updateOptions= this._updateOptions.bind(this);
		this._selectedFeatures=[];
		this._mapFeatureIdToOption = new Map();
		this._iMenuManager  = null;
		this.state = {options:[], visible:false};
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._selectedOptionsChangedOnce = new Once(onSelectedOptionsChange);
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}
	filterPlots(plotsArray){
		const selectedFeatures = this._checkboxFilter.current.getCheckedValues();
		if(selectedFeatures.length<1)
			return plotsArray;
		return plotsArray.filter(siteJsonUnitPlot=>{
			for(var selectedFeature of selectedFeatures){
				if(siteJsonUnitPlot.features===undefined
				||siteJsonUnitPlot.features===null)
					return false;
				if(siteJsonUnitPlot.features.indexOf(selectedFeature)<0)
					return false;
			}
			return true;
		});
	}
	clear(){
		this._checkboxFilter.current.clear();
	}
	setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel){
		/*const houseTypeViewModels = whatAreYouLookingForViewModel.houseTypes;
		if(!houseTypeViewModels)return;
		this._setHouseTypeViewModelsToShow(houseTypeViewModels);*/
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.FEATURES_FILTER;
	}
	get isApplied(){
		return this._checkboxFilter.current.isApplied;
	}
	load({siteJson}){
		this._siteJson = siteJson;
		this._propertyBindingAllFeatures = PropertyBindingFactory.standard(this, 
			siteJson, 'allFeatures', this._updateOptions);
	}
	_handleSelectedOptionsChanged(o){
		const selectedFeatures = this._checkboxFilter.current.getCheckedValues();
		this._setSelectedFeatures(selectedFeatures);
		this._callbackSelectedOptionsChange();
	}
	_setSelectedFeatures(selectedFeatures){
		this._selectedFeatures = selectedFeatures;
		this._siteJson.allFeatures?.forEach((feature)=>{
			const option = this._mapFeatureIdToOption.get(feature.id);
			option.isChecked = this._selectedFeatures.indexOf(feature)>=0;
		});
	}
	_updateOptions(){
		this._mapFeatureIdToOption.clear();
		if(!this._siteJson.allFeatures)return;
		const options = this._siteJson.allFeatures.map((feature)=>{
			const option = new Option({
				text:feature.name,
				value:feature
			});
			this._mapFeatureIdToOption.set(feature.id, option);
			return option;
		});
		this._checkboxFilter.current.setOptions(options);
	}
	render() {
		let className ="features-filter  menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Features"></SubMenuHeader>
				<CheckboxFilter ref={this._checkboxFilter} onSelectionChange={this._handleSelectedOptionsChanged}></CheckboxFilter></div>)
	}
}
